import AuthService from "../services/auth.service";
import jwt_decode from "jwt-decode";

var initialState;
const user = JSON.parse(localStorage.getItem("user"));
if (user) {
  //check if token is expired
  const decoded = jwt_decode(user.accessToken)
  const current_time = Date.now() / 1000;
  if ( decoded.exp < current_time) {
    //expired
    console.debug('expired')
    initialState  =  { 
      status: { 
        loggedIn: false 
      }, 
      user: null 
    };
  } else {
    console.debug('not expired')
    initialState = { 
      status: { 
        loggedIn: true 
      }, 
      user: user
    }
  }
  console.log(jwt_decode(user.accessToken))
} else {
  console.debug('no user')
  initialState =  { 
    status: { 
      loggedIn: false 
    }, 
    user: null 
  };
}

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      commit("loginSuccess", user);
    },
    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        error => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};
